import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

import { useSvgId } from 'src/lib/hooks';

export const IconMeta = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  const svgId1 = useSvgId();
  const svgId2 = useSvgId();

  return (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 20 20"
      data-fill-none
    >
      <path
        d="M3.7282 11.5969C3.7282 12.1728 3.86229 12.6131 4.03756 12.8801C4.13096 13.0321 4.26546 13.1582 4.42739 13.2454C4.58932 13.3327 4.77292 13.3781 4.95952 13.377C5.41021 13.377 5.82251 13.2723 6.61705 12.2377C7.25358 11.4089 8.00362 10.2482 8.50883 9.51518L9.36347 8.27958C9.95716 7.42147 10.6432 6.46754 11.4322 5.81885C12.0748 5.29319 12.7687 5 13.467 5C14.6393 5 15.756 5.63927 16.6107 6.83822C17.546 8.15131 18.0017 9.80524 18.0017 11.512C18.0017 12.5267 17.7891 13.2723 17.4275 13.8613C17.0786 14.4309 16.3953 15 15.2497 15V13.377C16.2306 13.377 16.4738 12.5288 16.4738 11.5581C16.4738 10.1749 16.131 8.63979 15.376 7.54293C14.8402 6.76492 14.1458 6.28953 13.3818 6.28953C12.5556 6.28953 11.8907 6.87592 11.1434 7.92147C10.7461 8.47696 10.3383 9.15393 9.88037 9.9178L9.37627 10.7555C8.36361 12.445 8.10711 12.8298 7.60078 13.4649C6.71498 14.5812 5.95716 15 4.95952 15C3.77605 15 3.02768 14.5178 2.56698 13.7911C2.18584 13.199 2 12.422 2 11.5366L3.7282 11.5969Z"
        fill="#0081FB"
      />
      <path
        d="M3.36328 6.95288C4.1556 5.80366 5.29902 5 6.61046 5C7.36996 5 8.125 5.20942 8.91343 5.81728C9.77586 6.47958 10.6939 7.57016 11.8418 9.36754L12.253 10.0126C13.2456 11.5686 13.8109 12.3686 14.1409 12.7466C14.566 13.2314 14.8642 13.3749 15.2503 13.3749C16.2313 13.3749 16.4744 12.5267 16.4744 11.556L17.999 11.511C17.999 12.5257 17.7864 13.2712 17.4248 13.8602C17.0792 14.4309 16.396 15 15.2503 15C14.5381 15 13.9072 14.8545 13.2094 14.2351C12.6731 13.7597 12.046 12.9152 11.5636 12.156L10.1286 9.90052C9.40863 8.76859 8.74818 7.92461 8.36592 7.5445C7.95418 7.13141 7.42616 6.63508 6.58264 6.63508C5.89993 6.63508 5.32016 7.08586 4.83497 7.77539L3.36328 6.95288Z"
        fill={`url(#${svgId1})`}
      />
      <path
        d="M6.582 6.63508C5.89929 6.63508 5.31952 7.08586 4.83433 7.77539C4.14828 8.74974 3.7282 10.201 3.7282 11.5969C3.7282 12.1728 3.86229 12.6131 4.03756 12.8801L2.5642 13.7911C2.18584 13.199 2 12.422 2 11.5366C2 9.9267 2.46961 8.24869 3.36264 6.95288C4.15496 5.80366 5.29837 5 6.60982 5L6.582 6.63508Z"
        fill={`url(#${svgId2})`}
      />
      <defs>
        <linearGradient
          id={svgId1}
          x1="5.46928"
          y1="9.74084"
          x2="16.4825"
          y2="10.332"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0064E1" />
          <stop
            offset="0.4"
            stopColor="#0064E1"
          />
          <stop
            offset="0.83"
            stopColor="#0073EE"
          />
          <stop
            offset="1"
            stopColor="#0082FB"
          />
        </linearGradient>
        <linearGradient
          id={svgId2}
          x1="4.30463"
          y1="12.2775"
          x2="4.30463"
          y2="8.4555"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0082FB" />
          <stop
            offset="1"
            stopColor="#0064E0"
          />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
});
IconMeta.displayName = 'IconMeta';
